/* Global, cart-drawer-only presentation for the A Clean Slate bundle. */
(() => {
  const BUNDLE_TAG = 'apology-luxury-box-2026';
  const CARD_ATTRIBUTE = 'data-apology-bundle-cart-card';
  const SOURCE_CLASS = 'apology-bundle-cart__source';
  const DRAWER_SELECTOR = '.ocu-cart-drawer';
  const LINE_SELECTOR = '.ocu-cart-line-item-wrapper';

  const injectStyles = () => {
    if (document.getElementById('apology-bundle-drawer-styles')) return;
    const styles = document.createElement('style');
    styles.id = 'apology-bundle-drawer-styles';
    styles.textContent = `
      .ocu-cart-drawer .${SOURCE_CLASS} { display: none !important; }
      .ocu-cart-drawer .apology-bundle-cart-card {
        margin: 0 0 1rem;
        padding: 1rem;
        border: 1px solid #d7d7d7;
        border-radius: 8px;
        background: #fff;
        color: #1e1e1e;
        font-family: inherit;
      }
      .ocu-cart-drawer .apology-bundle-cart-card__top {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: .75rem;
      }
      .ocu-cart-drawer .apology-bundle-cart-card__main {
        display: grid;
        grid-template-columns: 68px minmax(0, 1fr);
        align-items: start;
        gap: .8rem;
      }
      .ocu-cart-drawer .apology-bundle-cart-card__image {
        display: block;
        width: 68px;
        height: 68px;
        border-radius: 5px;
        object-fit: cover;
      }
      .ocu-cart-drawer .apology-bundle-cart-card__content { min-width: 0; }
      .ocu-cart-drawer .apology-bundle-cart-card__eyebrow {
        margin: 0 0 .2rem;
        color: #5f5f5f;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: .08em;
      }
      .ocu-cart-drawer .apology-bundle-cart-card__title {
        margin: 0;
        color: #171717;
        font-size: 16px;
        font-weight: 700;
        line-height: 1.25;
      }
      .ocu-cart-drawer .apology-bundle-cart-card__quantity {
        display: inline-block;
        margin: .18rem 0 0 .25rem;
        padding: .12rem .38rem;
        border-radius: 999px;
        background: #e2f4e4;
        color: #256d32;
        font-size: 11px;
        font-weight: 800;
        letter-spacing: .02em;
        vertical-align: middle;
        white-space: nowrap;
      }
      .ocu-cart-drawer .apology-bundle-cart-card__remove {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 2.8rem;
        height: 2.8rem;
        appearance: none;
        border: 0;
        background: transparent;
        color: #4a4a4a;
        cursor: pointer;
        font: inherit;
        padding: .4rem;
      }
      .ocu-cart-drawer .apology-bundle-cart-card__remove:hover,
      .ocu-cart-drawer .apology-bundle-cart-card__remove:focus-visible {
        border-radius: 4px;
        background: #f0f0f0;
        color: #1e1e1e;
      }
      .ocu-cart-drawer .apology-bundle-cart-card__remove svg {
        width: 17px;
        height: 17px;
        fill: none;
        stroke: currentColor;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 1.8;
      }
      .ocu-cart-drawer .apology-bundle-cart-card__items {
        display: grid;
        gap: .35rem;
        margin: .85rem 0;
        padding: 0;
        list-style: none;
        color: #414141;
        font-size: 13px;
        line-height: 1.35;
      }
      .ocu-cart-drawer .apology-bundle-cart-card__items li::before {
        content: '✓';
        display: inline-block;
        margin-right: .45rem;
        color: #2e6b43;
        font-weight: 800;
      }
      .ocu-cart-drawer .apology-bundle-cart-card__total {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
        padding-top: .75rem;
        border-top: 1px solid #e4e4e4;
        color: #1e1e1e;
        font-size: 14px;
        font-weight: 700;
      }
      .ocu-cart-drawer .apology-bundle-cart-card__total strong { font-size: 16px; }
      .ocu-cart-drawer .apology-bundle-cart-card__message {
        margin: .7rem 0 0;
        padding: .6rem .7rem;
        border-radius: 5px;
        background: #f7f5f1;
        color: #404040;
        font-size: 12px;
        line-height: 1.4;
      }
      .ocu-cart-drawer .apology-bundle-cart-card__message-label {
        display: block;
        margin-bottom: .15rem;
        color: #1e1e1e;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: .04em;
        text-transform: uppercase;
      }
      .ocu-cart-drawer .apology-bundle-cart-card__message-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: .75rem;
      }
      .ocu-cart-drawer .apology-bundle-cart-card__message-edit {
        appearance: none;
        border: 0;
        background: transparent;
        color: #315c40;
        cursor: pointer;
        font: inherit;
        font-size: 12px;
        font-weight: 700;
        padding: .1rem 0;
        text-decoration: underline;
      }
      .ocu-cart-drawer .apology-bundle-cart-card__message-editor {
        display: grid;
        gap: .55rem;
        margin-top: .6rem;
      }
      .ocu-cart-drawer .apology-bundle-cart-card__message-editor textarea {
        width: 100%;
        min-height: 6.5rem;
        resize: vertical;
        border: 1px solid #c6c6c6;
        border-radius: 4px;
        background: #fff;
        color: #1e1e1e;
        font: inherit;
        font-size: 12px;
        line-height: 1.4;
        padding: .55rem;
      }
      .ocu-cart-drawer .apology-bundle-cart-card__message-actions {
        display: flex;
        justify-content: flex-end;
        gap: .65rem;
      }
      .ocu-cart-drawer .apology-bundle-cart-card__message-save,
      .ocu-cart-drawer .apology-bundle-cart-card__message-cancel {
        appearance: none;
        border: 0;
        background: transparent;
        cursor: pointer;
        font: inherit;
        font-size: 12px;
        padding: .25rem 0;
        text-decoration: underline;
      }
      .ocu-cart-drawer .apology-bundle-cart-card__message-save { color: #315c40; font-weight: 700; }
    `;
    document.head.appendChild(styles);
  };

  const taggedLines = (drawer) => Array.from(drawer.querySelectorAll(LINE_SELECTOR)).filter((line) => {
    try {
      return JSON.parse(line.dataset.properties || '{}')._apology_bundle === BUNDLE_TAG;
    } catch (_) {
      return false;
    }
  });

  const lineForHandle = (drawer, handle) => taggedLines(drawer).find((line) =>
    line.querySelector(`a[href*="/products/${handle}"]`)
  );

  const lineProperties = (line) => {
    try {
      return JSON.parse(line?.dataset.properties || '{}');
    } catch (_) {
      return {};
    }
  };

  const lineQuantity = (line) => {
    const value = Number.parseInt(line?.querySelector('.ocu-quantity-input')?.value || '1', 10);
    return Number.isFinite(value) && value > 0 ? value : 1;
  };

  const updateVisibleItemCount = (drawer, bundleLines, setQuantity) => {
    const count = drawer.querySelector('.ocu-cart-header--items-count');
    if (!count) return;
    const nonBundleQuantity = Array.from(drawer.querySelectorAll(LINE_SELECTOR))
      .filter((line) => !bundleLines.includes(line))
      .reduce((total, line) => total + lineQuantity(line), 0);
    const text = String(Math.max(1, nonBundleQuantity + setQuantity));
    if (count.textContent !== text) count.textContent = text;
  };

  const rawDrawerItemCount = (drawer) => Array.from(drawer.querySelectorAll(LINE_SELECTOR))
    .reduce((total, line) => total + lineQuantity(line), 0);

  const setLabel = (quantity) => quantity === 1 ? 'Complete set' : `${quantity} complete gift sets`;

  // Price data comes from Shopify, matched to the exact drawer line keys.
  const REQUIRED_VARIANTS = ['58569543319816', '41716770373799', '44990985994504', '41673932243111'];
  const bundleCartQuote = (cart, lines) => {
    if (!Array.isArray(cart?.items) || !/^[A-Z]{3}$/.test(cart.currency || '')) return null;
    const items = cart.items.filter((item) => item.properties?._apology_bundle === BUNDLE_TAG);
    if (items.length !== 4 || lines.length !== 4) return null;
    const ids = new Set(items.map((item) => String(item.variant_id ?? item.id)));
    if (ids.size !== 4 || REQUIRED_VARIANTS.some((id) => !ids.has(id))) return null;
    const quantity = items.find((item) => String(item.variant_id ?? item.id) === REQUIRED_VARIANTS[0]).quantity;
    if (!Number.isSafeInteger(quantity) || quantity < 1) return null;
    if (items.some((item) => item.quantity !== quantity
      || !Number.isSafeInteger(item.final_line_price) || item.final_line_price < 0)) return null;
    if (new Set(lines.map((line) => line.dataset.key)).size !== 4
      || lines.some((line) => !items.some((item) => item.key === line.dataset.key
        && item.quantity === lineQuantity(line)))) return null;
    const subtotal = items.reduce((sum, item) => sum + item.final_line_price, 0);
    // Order discounts aren't necessarily assigned to individual lines by Ajax.
    // For a bundle-only cart the authoritative cart total includes them exactly.
    const amount = cart.items.length === 4 ? cart.total_price : subtotal;
    if (!Number.isSafeInteger(amount) || amount < 0) return null;
    const beforeOrderDiscounts = cart.items.length !== 4
      && (cart.cart_level_discount_applications || []).some((discount) => discount.total_allocated_amount > 0);
    return { amount, currency: cart.currency, quantity, beforeOrderDiscounts };
  };
  const formatBundleMoney = (amount, currency) => new Intl.NumberFormat(window.Shopify?.locale || 'en-US', {
    style: 'currency', currency
  }).format(amount / 100) + ' ' + currency;
  const setTotal = (quote) => formatBundleMoney(quote.amount, quote.currency);
  const quoteLabel = (quote) => setLabel(quote.quantity)
    + (quote.beforeOrderDiscounts ? ' (before order discounts)' : '');
  const restoreSourceLines = (drawer, card) => {
    card?.remove();
    drawer.querySelectorAll(`.${SOURCE_CLASS}`).forEach((line) => line.classList.remove(SOURCE_CLASS));
    const count = drawer.querySelector('.ocu-cart-header--items-count');
    if (count && count.textContent !== String(rawDrawerItemCount(drawer))) count.textContent = String(rawDrawerItemCount(drawer));
  };
  let renderRevision = 0;

  const updateBundleCardQuantity = (card, quote) => {
    const quantity = quote.quantity;
    const badge = card.querySelector('[data-apology-bundle-quantity]');
    const label = card.querySelector('[data-apology-bundle-total-label]');
    const total = card.querySelector('[data-apology-bundle-total]');
    if (badge && badge.textContent !== `× ${quantity}`) badge.textContent = `× ${quantity}`;
    if (label && label.textContent !== quoteLabel(quote)) label.textContent = quoteLabel(quote);
    if (total && total.textContent !== setTotal(quote)) total.textContent = setTotal(quote);
  };

  const refreshDrawer = () => {
    window.SLIDECART_UPDATE?.();
    window.UPDATE_CART?.();
    document.dispatchEvent(new CustomEvent('ocu:cart:update'));
  };

  const updateLineProperties = async (line, properties) => {
    const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: line.dataset.key,
        quantity: Number.parseInt(line.querySelector('.ocu-quantity-input')?.value || '1', 10) || 1,
        properties
      })
    });
    if (!response.ok) throw new Error('Could not update the gift message.');
    return response.json();
  };

  const renderBundleCard = async () => {
    const revision = ++renderRevision;
    injectStyles();
    const drawer = document.querySelector(DRAWER_SELECTOR);
    if (!drawer) return;

    const lines = taggedLines(drawer);
    const existingCard = drawer.querySelector(`[${CARD_ATTRIBUTE}]`);

    if (lines.length !== 4) {
      restoreSourceLines(drawer, existingCard);
      return;
    }

    let quote;
    const abort = new AbortController();
    const timeout = window.setTimeout(() => abort.abort(), 8000);
    const displayedTotal = existingCard?.querySelector('[data-apology-bundle-total]');
    if (displayedTotal && displayedTotal.textContent !== '…') displayedTotal.textContent = '…';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', { cache: 'no-store', credentials: 'same-origin', signal: abort.signal });
      if (!response.ok) throw new Error('Cart prices unavailable.');
      quote = bundleCartQuote(await response.json(), lines);
    } catch (_) { quote = null; }
    finally { window.clearTimeout(timeout); }
    if (revision !== renderRevision || !drawer.isConnected || lines.some((line) => !drawer.contains(line))) return;
    if (!quote) { restoreSourceLines(drawer, existingCard); return; }
    const list = lines[0].parentElement;
    if (!list) return;
    const parentLine = lineForHandle(drawer, 'a-clean-slate-apology-gift-bundle-luxury-box-set-shop-26836-2782') || lines[0];
    const setQuantity = quote.quantity;
    lines.forEach((line) => line.classList.add(SOURCE_CLASS));
    updateVisibleItemCount(drawer, lines, setQuantity);

    if (existingCard) {
      updateBundleCardQuantity(existingCard, quote);
      return;
    }

    const giftWrapLine = lineForHandle(drawer, 'gift-wrap-with-personalized-message');
    const productImage = parentLine.querySelector('img');
    const imageUrl = productImage?.currentSrc || productImage?.src || '';
    let giftMessage = '';
    const giftProperties = lineProperties(giftWrapLine);
    giftMessage = String(giftProperties['Gift note'] || giftProperties._gift_note || '').trim();

    const card = document.createElement('section');
    card.className = 'apology-bundle-cart-card';
    card.setAttribute(CARD_ATTRIBUTE, '');
    card.innerHTML = `
      <div class="apology-bundle-cart-card__main">
        ${imageUrl ? '<img class="apology-bundle-cart-card__image" alt="A Clean Slate Apology Gift Set">' : ''}
        <div class="apology-bundle-cart-card__content">
          <div class="apology-bundle-cart-card__top">
            <div>
              <p class="apology-bundle-cart-card__eyebrow">COMPLETE GIFT SET</p>
              <p class="apology-bundle-cart-card__title">A Clean Slate Apology Gift Set <span class="apology-bundle-cart-card__quantity" data-apology-bundle-quantity>× ${setQuantity}</span></p>
            </div>
            <button type="button" class="apology-bundle-cart-card__remove" data-apology-bundle-remove aria-label="Remove complete gift set" title="Remove complete gift set">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M9 7l1-2h4l1 2M6 7l1 13h10l1-13" /></svg>
            </button>
          </div>
          <ul class="apology-bundle-cart-card__items">
            <li>14K White Gold Love Knot Necklace with Luxury Box</li>
            <li>Love Knot Stud Earrings</li>
            <li>Gift Wrap with optional personal message</li>
            <li>Signature Gift Bag with tissue paper</li>
          </ul>
          <div class="apology-bundle-cart-card__total"><span data-apology-bundle-total-label>${quoteLabel(quote)}</span><strong data-apology-bundle-total>${setTotal(quote)}</strong></div>
        </div>
      </div>
    `;
    if (imageUrl) card.querySelector('.apology-bundle-cart-card__image').src = imageUrl;
    const message = document.createElement('p');
    message.className = 'apology-bundle-cart-card__message';
    const head = document.createElement('span');
    head.className = 'apology-bundle-cart-card__message-head';
    const label = document.createElement('span');
    label.className = 'apology-bundle-cart-card__message-label';
    label.textContent = giftMessage ? 'Your gift message' : 'Gift message';
    const edit = document.createElement('button');
    edit.type = 'button';
    edit.className = 'apology-bundle-cart-card__message-edit';
    edit.dataset.apologyBundleMessageEdit = '';
    edit.textContent = giftMessage ? 'Edit' : 'Add message';
    const text = document.createElement('span');
    text.dataset.apologyBundleMessageText = '';
    text.textContent = giftMessage ? `“${giftMessage}”` : 'No message added.';
    head.append(label, edit);
    message.append(head, text);
    card.querySelector('.apology-bundle-cart-card__content').appendChild(message);
    list.insertBefore(card, lines[0]);
  };

  const openMessageEditor = (button) => {
    const card = button.closest(`[${CARD_ATTRIBUTE}]`);
    if (!card || card.querySelector('[data-apology-bundle-message-editor]')) return;

    const messageBox = button.closest('.apology-bundle-cart-card__message');
    const current = messageBox.querySelector('[data-apology-bundle-message-text]')?.textContent || '';
    const initialValue = current === 'No message added.' ? '' : current.replace(/^“|”$/g, '');
    const editor = document.createElement('div');
    editor.className = 'apology-bundle-cart-card__message-editor';
    editor.dataset.apologyBundleMessageEditor = '';
    editor.innerHTML = `
      <textarea maxlength="98" rows="3" aria-label="Gift message" placeholder="Write your message here"></textarea>
      <div class="apology-bundle-cart-card__message-actions">
        <button type="button" class="apology-bundle-cart-card__message-cancel" data-apology-bundle-message-cancel>Cancel</button>
        <button type="button" class="apology-bundle-cart-card__message-save" data-apology-bundle-message-save>Save message</button>
      </div>
    `;
    messageBox.appendChild(editor);
    button.hidden = true;
    const textarea = editor.querySelector('textarea');
    textarea.value = initialValue;
    textarea.focus();
  };

  const closeMessageEditor = (button) => {
    const messageBox = button.closest('.apology-bundle-cart-card__message');
    messageBox?.querySelector('[data-apology-bundle-message-editor]')?.remove();
    const edit = messageBox?.querySelector('[data-apology-bundle-message-edit]');
    if (edit) edit.hidden = false;
  };

  const saveMessage = async (button) => {
    const card = button.closest(`[${CARD_ATTRIBUTE}]`);
    const drawer = button.closest(DRAWER_SELECTOR);
    const editor = button.closest('[data-apology-bundle-message-editor]');
    const message = editor?.querySelector('textarea')?.value.trim();
    const giftWrapLine = lineForHandle(drawer, 'gift-wrap-with-personalized-message');
    if (!card || !drawer || !editor || !giftWrapLine) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Saving…';
    try {
      const giftWrapProperties = lineProperties(giftWrapLine);
      const parentLine = lineForHandle(drawer, 'a-clean-slate-apology-gift-bundle-luxury-box-set-shop-26836-2782');
      const parentProperties = lineProperties(parentLine);

      if (message) {
        giftWrapProperties['Gift note'] = message;
        giftWrapProperties._gift_note = message;
        giftWrapProperties._gift_note_variant_id = '44990985994504';
        parentProperties._gift_note = message;
        parentProperties._gift_note_variant_id = '44990985994504';
      } else {
        delete giftWrapProperties['Gift note'];
        delete giftWrapProperties._gift_note;
        delete giftWrapProperties._gift_note_variant_id;
        delete parentProperties._gift_note;
        delete parentProperties._gift_note_variant_id;
      }

      // Shopify replaces a full properties object on cart/change.js, so retain
      // the private bundle marker and ShineOn's required Gift Wrap assignment.
      await updateLineProperties(giftWrapLine, giftWrapProperties);
      if (parentLine) await updateLineProperties(parentLine, parentProperties);
      card.remove();
      refreshDrawer();
      window.setTimeout(renderBundleCard, 500);
    } catch (_) {
      button.disabled = false;
      button.textContent = originalText;
    }
  };

  const removeBundle = async (button) => {
    const drawer = button.closest(DRAWER_SELECTOR);
    if (!drawer) return;
    const updates = Object.fromEntries(taggedLines(drawer).map((line) => [line.dataset.key, 0]));
    if (Object.keys(updates).length !== 4) return;

    button.disabled = true;
    button.textContent = 'Removing…';
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates })
      });
      if (!response.ok) throw new Error('Could not remove the set.');
      refreshDrawer();
      window.setTimeout(renderBundleCard, 500);
    } catch (_) {
      button.disabled = false;
      button.textContent = 'Remove';
    }
  };

  let renderTimer;
  const scheduleRender = () => {
    ++renderRevision;
    window.clearTimeout(renderTimer);
    renderTimer = window.setTimeout(renderBundleCard, 120);
  };

  document.addEventListener('ocu:cart:open', scheduleRender);
  document.addEventListener('ocu:cart:updated', scheduleRender);
  document.addEventListener('ocu:cart:update', scheduleRender);
  document.addEventListener('change', (event) => {
    if (event.target.matches?.('.ocu-quantity-input')) scheduleRender();
  });
  window.addEventListener('pageshow', scheduleRender);
  document.addEventListener('apology:bundle-added', scheduleRender);
  document.addEventListener('click', (event) => {
    const removeButton = event.target.closest('[data-apology-bundle-remove]');
    if (removeButton) {
      removeBundle(removeButton);
      return;
    }
    const editButton = event.target.closest('[data-apology-bundle-message-edit]');
    if (editButton) {
      openMessageEditor(editButton);
      return;
    }
    const cancelButton = event.target.closest('[data-apology-bundle-message-cancel]');
    if (cancelButton) {
      closeMessageEditor(cancelButton);
      return;
    }
    const saveButton = event.target.closest('[data-apology-bundle-message-save]');
    if (saveButton) saveMessage(saveButton);
  });

  new MutationObserver((records) => {
    // Ignore our own card/count/style writes, otherwise each price refresh
    // would trigger another GET forever. Listen to source rows and app updates.
    if (records.some((record) => {
      if (record.target.closest?.(`[${CARD_ATTRIBUTE}], .ocu-cart-header--items-count, #apology-bundle-drawer-styles`)) return false;
      const nodes = [...record.addedNodes, ...record.removedNodes];
      if (!record.target.closest?.(DRAWER_SELECTOR)) return nodes.some((node) => node.nodeType === 1
        && (node.matches?.(DRAWER_SELECTOR) || node.querySelector?.(DRAWER_SELECTOR)));
      return !nodes.length || !nodes.every((node) => node.nodeType === 1
        && node.matches?.(`[${CARD_ATTRIBUTE}], #apology-bundle-drawer-styles`));
    })) scheduleRender();
  }).observe(document.documentElement, { childList: true, subtree: true });
  scheduleRender();
})();